import { PutQuoteJobCatCount } from "../put-models/put-quote-job-cat-count";

export class ResponseQuoteJobCatCount extends PutQuoteJobCatCount {
    isFresh?:boolean;
}